module.exports = __webpack_public_path__ + "static/undraw_city_life_gnpr-5e106f8589600a63ba7f679450f00c62.svg";